import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, scrollToId } from "./shared";
import { IMG } from "../data/site";

export function FinalCTA({ onAdvisor, onInventory }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "0%"]);

  return (
    <section ref={ref} className="relative py-36 lg:py-56 overflow-hidden" data-testid="final-cta-section">
      <motion.div className="absolute inset-0" style={{ y }}>
        <img src={IMG.nightCity} alt="Night aerial of the emerging corridor" className="w-full h-[125%] object-cover img-cinematic" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_10%,rgba(10,10,10,0.9)_100%)]" />
      </motion.div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 text-center">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.42em] text-[#D4AF37] mb-8">The Invitation</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-7xl leading-[1.05]" data-testid="final-cta-headline">
            <span className="text-[#F5F5F0]">The Next Chapter of NCR </span><br />
            <span className="text-gold-gradient italic">Is Being Written Here.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-7 text-sm sm:text-base text-[#A1A1AA] max-w-xl mx-auto">
            Discover Gaur Yamuna City. Understand the corridor. Choose your opportunity.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <button data-testid="final-explore-btn" onClick={() => scrollToId("gyc")} className="px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black hover:from-[#D4AF37] hover:to-[#F3E5AB] transition-colors rounded-[2px]">
              Explore GYC
            </button>
            <button data-testid="final-inventory-btn" onClick={onInventory} className="px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] border border-[#D4AF37]/50 text-[#F3E5AB] hover:bg-[#D4AF37]/10 transition-colors rounded-[2px]">
              Get Current Inventory
            </button>
            <button data-testid="final-advisor-btn" onClick={onAdvisor} className="px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#A1A1AA] hover:text-[#F3E5AB] underline underline-offset-8 decoration-[#D4AF37]/40 transition-colors">
              Talk to Radiance Realtors
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
